/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { appInsights } from '@ao/app/app.config';

@Injectable()
export class HttpLoggingInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const startTime = Date.now();

    // Log the outgoing request
    appInsights.trackEvent({
      name: 'HttpRequest',
      properties: {
        method: req.method,
        url: req.urlWithParams,
        headers: JSON.stringify(req.headers.keys()),
        body: req.body ? JSON.stringify(req.body) : null,
        timestamp: new Date().toISOString(),
      },
    });

    return next.handle(req).pipe(
      tap({
        next: event => {
          if (event instanceof HttpResponse) {
            const duration = Date.now() - startTime;

            // Log the incoming response
            appInsights.trackEvent({
              name: 'HttpResponse',
              properties: {
                method: req.method,
                url: req.urlWithParams,
                status: event.status,
                statusText: event.statusText,
                responseBody: JSON.stringify(event.body),
                duration: `${duration}ms`,
                timestamp: new Date().toISOString(),
              },
            });
          }
        },
        error: (error: HttpErrorResponse) => {
          const duration = Date.now() - startTime;
          if (error) {
            // Log the error response
            appInsights.trackException({
              exception: error,
              properties: {
                method: req.method,
                url: req.urlWithParams,
                status: error.status,
                statusText: error.statusText,
                errorMessage: error.message,
                duration: `${duration}ms`,
                timestamp: new Date().toISOString(),
              },
            });
          }
        },
      })
    );
  }
}
